export default __webpack_public_path__ + "static/media/Emotion_Love.2b2d0d1b.svg";